<template>
  <div class="fixed inset-0 bg-gray-900/50 flex justify-center items-center p-4 z-50">
    <div class="bg-white p-4 rounded-lg shadow"
         style="width: 400px"
    >
      <div class="font-bold py-2 flex justify-between">
        Change Object Owner
        <Multi_Button :button-char="'X'" :emission="'close'" @close="closeForm" />
      </div>
      <form @submit.prevent="submitForm">
        <div class="py-2 mb-5 ">
          <label for="user" class="block text-md font-medium text-gray-700 mb-2">Select User</label>
          <select
            id="user"
            v-model="appUserId"
            class="p-2 mt-1 text-md block border rounded-md w-full"
          >
            <option :value="null" disabled>Select a user</option>
            <option v-for="appuser in appusers" :key="appuser.id" :value="appuser.id" class="sensitive">
              {{ appuser.full_name }}
            </option>
          </select>
        </div>
        <div class="flex justify-center gap-3">
          <button
            type="button"
            @click="closeForm"
            class="bg-gray-500 px-4 py-1 text-white rounded-md hover:bg-gray-600"
          >
            Cancel
          </button>
          <button
            type="submit"
            :disabled="!appUserId"
            class="bg-gray-700 px-4 py-1 text-white rounded-md hover:bg-gray-800 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Submit
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import Multi_Button from '@/components/widgetcomponents/Multi_Button.vue'

export default {
  name: 'FormUpdateObjectOwner',
  components: {Multi_Button},
  props: {
    objectId:{
      type:Number,
      required:true
    },
    contentTypeModel:{
      type:String,
      required:true
    },
    currentOwner:{
      type:Number
    }
  },
  data() {
    return {
      appusers:[],
      appUserId: this.currentOwner || null
    }
  },
  methods: {
    async fetchAppUsers() {
      try {
        const response = await axios.get('/api/user/')
        this.appusers = response.data
          .filter(item => item.full_name && item.full_name.length > 1)
          .sort((a, b) => a.full_name.localeCompare(b.full_name))
      } catch (error) {
        console.error('Error fetching users:', error)
      }
    },
    closeForm() {
      this.$emit('close', {
        refreshData: false
      })
    },
    async submitForm() {
      if(!this.contentTypeModel || !this.objectId || !this.appUserId){
        console.error('Missing required fields for form submission')
        return
      }

      try {
        // Construct the correct API endpoint based on content type
        let apiEndpoint = '';
        let payload = {};
        
        if (this.contentTypeModel === 'action') {
          apiEndpoint = `/api/graph-actions/${this.objectId}/updateowner/`;
          payload = {
            owner_object_id: this.appUserId,
            owner_content_type_model: 'appuser'
          };
        } else if (this.contentTypeModel === 'alertinstance') {
          apiEndpoint = `/api/impact_analytics/composable-alert-instances/${this.objectId}/`;
          payload = {
            assigned_to: this.appUserId
          };
        } else {
          // Generic endpoint for other content types
          apiEndpoint = `/api/${this.contentTypeModel}/${this.objectId}/updateowner/`;
          payload = {
            owner_object_id: this.appUserId,
            owner_content_type_model: 'appuser'
          };
        }

        await axios.patch(apiEndpoint, payload)

        this.$emit('close', {
          refreshData: true
        })
      } catch (error) {
        console.error('Failed to update owner', error)
        alert('Failed to update owner. Please try again.')
      }
    },
  },
  mounted() {
    this.fetchAppUsers()
  }
}
</script>
